import { render, staticRenderFns } from "./azienda-agricola-casanova-di-neri.vue?vue&type=template&id=7c24d84e&scoped=true"
import script from "./azienda-agricola-casanova-di-neri.vue?vue&type=script&lang=js"
export * from "./azienda-agricola-casanova-di-neri.vue?vue&type=script&lang=js"
import style0 from "./azienda-agricola-casanova-di-neri.vue?vue&type=style&index=0&id=7c24d84e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c24d84e",
  null
  
)

export default component.exports